/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: false // Set to false to use static SVG
};

const greeting = {
  username: "Niklas Iivari",
  title: "Niklas Iivari",
  //subTitle: "I am a Computer Science student from Helsinki, Finland. I started my studies in Aalto University in 2023.",
  //description: "This website is a portfolio that displays some of my work experience, skills and education, as well as a gallery of my photography.",
  resumeLink:
    "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/niklasiivari",
  linkedin: "https://www.linkedin.com/in/niklasiivari/",
  gmail: "info@niklasiivari.fi",
  gitlab: "",
  facebook: "",
  medium: "",
  stackoverflow: "",
  instagram: "https://www.instagram.com/niklasiivari/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

//Gallery Section

const gallerySection = {
  display: true

}

//Pdf section

const PdfSection = {
  display: false,
  pdfs: [
      require("./assets/pdfs/MathIA.pdf"),
      require("./assets/pdfs/EE.pdf"),
      require("./assets/pdfs/ChemIA.pdf"),
    ],
}

// Skills Section

const skillsSection = {
  title: "Skills",
  subTitle: "",
  skills: [
    emoji(
      ""
    ),
    emoji(""),
    emoji(
      ""
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "scala",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "sql",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "LaTeX",
      fontAwesomeClassname: "fas fa-align-left"
    },
    {
      skillName: "Microsoft 365 admin",
      fontAwesomeClassname: "fas fa-user-cog"
    },
    {
      skillName: "Photography",
      fontAwesomeClassname: "fas fa-camera"
    },
  ],
  display: false // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: false, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Aalto University, Espoo",
      darklogo: require("./assets/images/aalto1.png"),
      logo: require("./assets/images/aalto.png"),
      subHeader: "Bachelor of Science, Computer Science",
      duration: "August 2023 - Present",
      desc: "",
      descBullets: [
        "Programming: Scala, SQL",
        "Mathematics",
        "Physics",
      ]
    },
    {
      schoolName: "Lyseonpuiston Lukio, Rovaniemi",
      darklogo: require("./assets/images/IB.png"),
      logo: require("./assets/images/IB.png"),
      subHeader: "International Baccalaureate Diploma Programme",
      duration: "August 2019 - June 2022",
      desc: "I was awarded the IB diploma with a score of 44/45. I studied the following subjects:",
      descBullets: [
        "Mathematics",
        "Physics",
        "Chemistry",
        "Economics",
        "English",
        "Finnish"
      ]
    },
    
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Photo Salesperson",
      company: "Tunnin Kuva, Vantaa",
      date: "May 2024 – Present",
      descBullets: [
        "Took portraits and passport pictures",
        "Provided customers with pleasant and helpful service",
        "Photo editing and Graphic design",
        "Photo printing with professional equipment"
      ]
    },
    {
      role: "Court Clerk & Civilian service",
      company: "Lapland District Court, Rovaniemi",
      date: "August 2022 – August 2023",
      descBullets: [
        "Processed document orders: Received orders, Serached for the correct documents, Was in contact with clients, etc.",
        "Scanned and recorded summonses, responses/statements into Notes and Aipa",
        "Filed case files into folders",
        "Processed incoming and outcoming mail",
        "Assisted with other tasks"
      ]
    },
    {
      role: "Summer Employee",
      company: "Ecocom Oy, Rovaniemi",
      date: "June 2021",
      descBullets: [
        "Created presentation videos showcasing the company and its operations.",
        "Filmed and edited video content based on provided materials and instructions.",
        "Delivered high-quality, polished videos that met client expectations."
    ]
    },
    {
      role: "Summer Employee",
      company: "City of Rovaniemi",
      company2: "Employment Services Unit",
      //companylogo: require("./assets/images/airbnbLogo.png"),
      date: "June 2019 - July 2019",
      descBullets: [
        "Video Production and Editing: Created and edited video marketing materials for Nuorten Ohjaamo.",
        "Photography: Captured photos utilized in Nuorten Ohjaamo's operations.",
        "Social Media Management: Contributed to and updated Nuorten Ohjaamo's social media platforms.",
        "Content Creation: Developed content for social media and other marketing purposes.",
        "Interview Collaboration: Collaborated with a colleague to plan and execute an interview with the City of Rovaniemi's Economic Development Director.",
        "Diverse Daily Tasks: Participated in a variety of daily tasks to support Nuorten Ohjaamo's operations.",
        "Relocation Assistance: Assisted with moving efforts."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: "Contact me",
  subtitle:
    "",
  number: "",
  email_address: "info@niklasiivari.fi"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  gallerySection,
  PdfSection,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
